import moment from "moment";
import React from "react";
import { OrderLanguage } from "../../utils/Languages";
import MainComponentWrapper from "../Common/MainComponentWrapper";

const OrderUserSection = ({ isLoading, isError, details }) => {
  return (
    <MainComponentWrapper Loading={isLoading} errorInfo={isError}>
      <div className="event-order-detail-billing-list">
        <div className="event-order-detail-billing-item">
          <span className="event-order-detail-billing-label">
            {OrderLanguage.OrderDetails.billingSection.detialsColumn.email}
          </span>
          <span className="event-order-detail-billing-value">
            {details?.billingDetails?.email || "—"}
          </span>
        </div>
        <div className="event-order-detail-billing-item">
          <span className="event-order-detail-billing-label">
            {OrderLanguage.OrderDetails.billingSection.detialsColumn.date}
          </span>
          <span className="event-order-detail-billing-value">
            {details?.createdAt
              ? moment(details.createdAt).format("MMMM Do YYYY")
              : "—"}
          </span>
        </div>
      </div>
    </MainComponentWrapper>
  );
};

export default OrderUserSection;
